import { storyblokEditable } from "@storyblok/react";
import type {
  VideoBlockStoryblok,
  SectionTagItemStoryblok,
  AliniaStoryblok,
} from "../../../component-types-sb";
import Alinia from "../../elements/Alinia";
import "./video.scss";

const VideoComp = ({ blok }: { blok: VideoBlockStoryblok }) => {
  return (
    <section className="section-video" {...storyblokEditable(blok)}>
      <div className="text-container">
        {blok.tag &&
          blok.tag.map((blok: SectionTagItemStoryblok) => (
            <p
              key={blok._uid}
              className={`tag ${blok.color === "pink" ? "pink" : "black"}`}
            >
              {blok.text}
            </p>
          ))}
        {blok.alinea &&
          blok.alinea.map((blok: AliniaStoryblok) => (
            <Alinia key={blok._uid} className="text-video" text={blok.alinia} />
          ))}
        <div className="video-wrapper">
          <iframe
            title={blok.title_video || "Video"}
            src={blok.video_url}
            allow="autoplay; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default VideoComp;
